import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ataturkoglu/Documents/Pomza Export/pomzaexport_next/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ataturkoglu/Documents/Pomza Export/pomzaexport_next/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/Users/ataturkoglu/Documents/Pomza Export/pomzaexport_next/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ataturkoglu/Documents/Pomza Export/pomzaexport_next/src/components/homeBelowFoldLazy.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ataturkoglu/Documents/Pomza Export/pomzaexport_next/src/components/introVideo.jsx");
